// src/utils/formatPrice.js
import { currencyData } from "../context/CurrencyContext";

// The function now requires the 'rates' object from the context
export const formatPrice = (usdPrice, currencyCode, rates) => {
  const resolvedCurrency = currencyData[currencyCode] ? currencyCode : "FCFA";

  if (
    usdPrice === null ||
    usdPrice === undefined ||
    usdPrice === "" ||
    !currencyData[resolvedCurrency]
  ) {
    return "...";
  }

  const { symbol, position } = currencyData[resolvedCurrency];
  const isCFA = resolvedCurrency === "FCFA" || (symbol && symbol.toLowerCase().includes("cfa"));
  const displaySymbol = isCFA ? "CFA" : symbol;

  const formatNumber = (num) => {
    const val = parseFloat(num);
    if (isNaN(val)) return "0";
    // If CFA or integer, don't show redundant decimal cents (.00)
    const hasDecimals = !isCFA && val % 1 !== 0;
    return val.toLocaleString(undefined, {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: hasDecimals ? 2 : 0,
    });
  };

  if (typeof usdPrice === "object" && usdPrice.min && usdPrice.max) {
    if (String(usdPrice.min) === String(usdPrice.max)) {
      usdPrice = usdPrice.min;
    } else {
      const formattedMin = formatNumber(usdPrice.min);
      const formattedMax = formatNumber(usdPrice.max);

      return position === "before"
        ? `${displaySymbol} ${formattedMin} ~ ${displaySymbol} ${formattedMax}`
        : `${formattedMin} ~ ${formattedMax} ${displaySymbol}`;
    }
  }

  const formattedPrice = formatNumber(usdPrice);

  return position === "before"
    ? `${displaySymbol} ${formattedPrice}`
    : `${formattedPrice} ${displaySymbol}`;
};
